var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"120px"}},[_c('div',{staticClass:"welcome-box"},[_c('SpWelcome',{attrs:{"form":_vm.form,"mini-length":1}})],1),_c('div',{staticClass:"fotter-toolbar"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.onSubmit}},[_vm._v(" 立即创建 ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }